const types = require('../types');
const bitOperations = require('../bitOperations');

function parse(hexString) {
    const bits = bitOperations.hexStringToBitString(hexString);

    const idBits = bits.substring(12);
    const id = bitOperations.bitStringToDecString(idBits);

    let result = {
        hex: hexString.toUpperCase(),
        type: types.vueLic.id,
        vendorCode: id.substring(0, 2), //4 bits only. so safe to cast to int
        licensePlate: id.substring(2)
    };

    result.toString = function () {
        return `urn:epc:tag:${result.type}:${result.vendorCode}.${result.licensePlate}`;
    };
    result.toTitle = () => hexString.toUpperCase();
    return result;
}

module.exports = {
    parse
};
